"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when the service being called rejects the current user
 * @param {string} reason
 */
class UnauthorizedError extends ExtendableError_1.default {
    constructor(reason) {
        super(`Unauthorized: ${reason}`);
        this.reason = reason;
    }
}
exports.default = UnauthorizedError;
